import LongSurveyUpload from "./LongSurveyUpload";

export default function Index() {
    return (
      <>
      <LongSurveyUpload/>
      </>
    );
}
